<template>
    <div class="">

        <div class="box has-background-success">
            <div class="level-item">
                <p class="title is-size-5">Statistics Of Selected Ipad Device</p>
            </div>
        </div>
        <div class="box">
            <div class="level">
                <div class="level-left">
                    <div class="level-item">
                        <table class="table is-narrow">
                            <tbody>
                                <tr>
                                    <th>Device Id:</th>
                                    <td>{{Device.id}}</td>
                                </tr>
                                <tr>
                                    <th>Device UUID:</th>
                                    <td>{{Device.devicE_UUID}}</td>
                                </tr>
                                <tr>
                                    <th>First Login Time :</th>
                                    <td> {{Device.firstLoginTime | longFormatFromDT}}</td>
                                </tr>
                                <tr>
                                    <th>Last Login Time :</th>
                                    <td>{{Device.lastLoginTime | longFormatFromDT}}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table class="table is-narrow">
                            <tbody>
                            <tr>
                                <th>TLC Last Logged In:</th>
                                <td>{{Device.tlcLastLoggedIn}}</td>
                            </tr>
                            <tr>
                                <th>Last Hearbeat DT:</th>
                                <td>{{Device.lastHeartBeat_DT | longFormatFromDT}}</td>
                            </tr>
                            <tr>
                                <th>Os Version :</th>
                                <td>{{Device.osVersion}}</td>
                            </tr>
                            <tr>
                                <th>App Version :</th>
                                <td>{{Device.appVersion}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <table class="table is-narrow">
                            <tbody>

                                <tr>
                                    <th>Total TLC:</th>
                                    <td>{{Device.totaL_TLC}}</td>
                                </tr>

                                <tr>
                                    <th>UTC Diff:</th>
                                    <td>{{Device.utC_DIFF}}</td>
                                </tr>

                                <tr>
                                    <th>last Latitude :</th>
                                    <td><a :href="'https://www.google.com/maps/@'+Device.lastLatitude+','+Device.lastLongitude+',20z'" target="_blank">{{Device.lastLatitude|formatFloatValue}}</a></td>

                                </tr>

                                <tr>
                                    <th>last Longitude :</th>
                                    <td><a :href="'https://www.google.com/maps/@'+Device.lastLatitude+','+Device.lastLongitude+',20z'" target="_blank">{{Device.lastLongitude|formatFloatValue}}</a></td>
                                </tr>



                            </tbody>
                        </table>

                        <table class="table is-narrow">
                            <tbody>
                                <tr>
                                    <th>Last Known LVC DT:</th>
                                    <td>{{Device.lastKnownOcc_LVC_DT}}</td>
                                </tr>
                                <tr>
                                    <th>BTO LVC:</th>
                                    <td>{{Device.btO_LVC}}</td>
                                </tr>
                                <tr>
                                    <th>AL LVC:</th>
                                    <td>{{Device.aL_LVC}}</td>
                                </tr>
                                <tr>
                                    <th>BTO SignedBy:</th>
                                    <td>{{Device.btoSignedBy}}</td>
                                </tr>
                                <tr>
                                    <th>AL SignedBy:</th>
                                    <td>{{Device.alSignedBy}}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

                <div class="level-right">

                    <div class="level-item">
                        <div class="field has-addons">
                            <p class="control">
                                <router-link :to="{ name: 'Efb' }" active-class = "is-active">
                                    <button class="button is-info" style="padding-right: 20px">
                                             <span class="icon">
                                              <i class="fas fa-long-arrow-alt-left"></i></span>
                                        <span>Back To Efb Devices</span>
                                    </button>
                                </router-link>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="box">

            <div class="columns">
                <!--Device Statistics geldiğinde yeşil gelmediğinde kırmızı -->
                <div class="column">
                    <article class="message">
                        <div class="message-header has-background-success">

                            <div class="level">
                                <div class="level-left left-main-level">
                                    <div class="level-item left-lable">
                                        <p class="title is-size-5">Device Statistics</p>
                                    </div>
                                </div>
                            </div>
                            <span class="icon"><font-awesome-icon icon="database" size="2x"/></span>
                        </div>
                        <div class="message-body details-main animate__animated animate__slideInDown animate__faster">
                            <div class="request-table">
                                <table class="table is-hoverable is-striped is-fullwidth is-bordered animate__animated animate__slideInUp animate__faster fontsizesmall">
                                    <thead class="sticky-head">
                                        <tr>
                                            <th>ID</th>
                                            <th>IPAD Device UID</th>
                                            <th>Username</th>
                                            <th>TLC</th>
                                            <th>First Login</th>
                                            <th>Last Login</th>
                                            <th>Last Heartbeat</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="device in this.deviceslistByuuid" :key="device.id">
                                            <td>{{device.id}}</td>
                                            <td>{{device.devicE_UUID}}</td>
                                            <td>{{device.username}}</td>
                                            <td>{{device.tlc}}</td>
                                            <td>{{device.firstLogin | longFormatFromDT}}</td>
                                            <td>{{device.lastLogin | longFormatFromDT}}</td>
                                            <td>{{device.lastHeartBeat_DT | longFormatFromDT}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </article>
                </div>

                <!--HearBeat Statistics statistics geldiğinde yeşil gelmediğinde kırmızı-->
                <div class="column">
                    <article class="message">

                        <div class="message-header has-background-success">
                            <div class="level">
                                <div class="level-left left-main-level">
                                    <div class="level-item left-lable">
                                        <p class="title is-size-5">Heartbeat Statistics</p>
                                    </div>
                                </div>
                            </div>
                            <span class="icon"><font-awesome-icon icon="database" size="2x"/></span>
                        </div>

                        <div class="message-body details-main animate__animated animate__slideInDown animate__faster">
                            <div class="request-table">
                                <table class="table is-narrow is-fullwidth is-narrow is-striped is-bordered animate__animated animate__faster animate__slideInUp fontsizesmall">
                                        <thead class="sticky-head">
                                            <tr>
<!--                                            <th>ID</th>                 -->
<!--                                            <th>ID_DEVICE</th>          -->
<!--                                            <th>DEVICE_UUID</th>        -->
                                                <th>Last SessionHash</th>
                                                <th>HeartBeat_DT</th>
                                                <th>Latitude</th>
                                                <th>Longitude</th>
                                                <th>isOnline</th>
                                                <th>Horizontal Accuracy</th>
                                                <th>Altitude</th>
                                                <th>Altitude Accuracy</th>
                                                <th>Course</th>
                                                <th>Course Accuracy</th>
                                                <th>Speed</th>
                                                <th>Speed Accuracy</th>
                                                <th>pos DT</th>
                                            </tr>
                                        </thead>
                                    <tbody>
                                        <tr v-for="device in this.heartbeatsignalsByuuid" :key="device.id">
<!--                                        <td>{{device.id}}</td>-->
<!--                                        <td>{{device.iD_DEVICE}}</td>-->
<!--                                        <td>{{device.devicE_UUID}}</td>-->
                                            <td>{{device.lastSessionHash}}</td>
                                            <td>{{device.heartbeatDT | longFormatFromDT}}</td>
                                            <td><a :href="'https://www.google.com/maps/@'+device.latitude+','+device.longitude+',20z'" target="_blank">{{device.latitude|formatFloatValue}}</a></td>
                                            <td><a :href="'https://www.google.com/maps/@'+device.latitude+','+device.longitude+',20z'" target="_blank">{{device.longitude|formatFloatValue}}</a></td>
                                            <td>{{device.isOnline}}</td>
                                            <td>{{device.horizontalAccuracy|formatFloatValue}}</td>
                                            <td>{{device.altitude|formatFloatValue}}</td>
                                            <td>{{device.altitudeAccuracy|formatFloatValue}}</td>
                                            <td>{{device.course}}</td>
                                            <td>{{device.courseAccuracy|formatFloatValue}}</td>
                                            <td>{{device.speed}}</td>
                                            <td>{{device.speedAccuracy|formatFloatValue}}</td>
                                            <td>{{device.posDT | longFormatFromDT}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>

        <div class="box">
            <div class="columns">
                <div class="column">
                    <article class="message">
                        <div class="message-header has-background-success">

                            <div class="level">
                                <div class="level-left left-main-level">
                                    <div class="level-item left-lable">
                                        <p class="title is-size-5">File Request History</p>
                                    </div>
                                </div>
                            </div>
                            <span class="icon"><font-awesome-icon icon="database" size="2x"/></span>
                        </div>
                        <div class="message-body details-main animate__animated animate__slideInDown animate__faster">

                            <div class="columns">

                                <div class="column">
                                    <button class="button is-large" @click="showIpadDeviceRequestModal('O')">
                                        <span class="icon is-medium">
                                          <font-awesome-icon icon="broadcast-tower" size="lg"/>
                                        </span>
                                        <span>OCC File Request</span>
                                    </button>
                                </div>

                                <div class="column">
                                    <button class="button is-large" @click="showIpadDeviceRequestModal('I')">
                                        <span class="icon is-medium">
                                            <font-awesome-icon icon="tablet-alt" size="lg"/>
                                        </span>
                                        <span>Input File Request</span>
                                    </button>
                                </div>

                                <div class="column">
                                    <button class="button is-large" @click="showIpadDeviceRequestModal('L')">
                                        <span class="icon is-medium">
                                            <font-awesome-icon icon="clipboard-list" size="lg"/>
                                        </span>
                                        <span>Log File Request</span>
                                    </button>
                                </div>

                                <div class="column">
                                    <button class="button is-large" @click="showIpadDeviceRequestModal('D')">
                                        <span class="icon is-medium">
                                          <font-awesome-icon icon="sitemap" size="lg"/>
                                        </span>
                                        <span>DIR File Request</span>
                                    </button>
                                </div>

                                <div class="column">
                                    <button class="button is-large" @click="showIpadDeviceRequestModal('M')">
                                        <span class="icon is-medium">
                                          <font-awesome-icon icon="map" size="lg"/>
                                        </span>
                                        <span>Map Request</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </div>

        <IpadDevicesRequestModal
                :isActiveIpadDeviceRequestModal = 'isActiveIpadDeviceRequestModal'
                :ActiveIpadDevice_UUID = 'ActiveIpadDevice_UUID'
                :ActiveReqType = 'ActiveReqType'
                :ActiveDevice = 'ActiveDevice'
                @closeIpadDeviceRequestModal="closeIpadDeviceRequestModal"/>
    </div>
</template>

<script>
    //import {mapState, mapActions} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";
    import {mapActions, mapState} from "vuex";
    import IpadDevicesRequestModal from "../../components/ui/IpadDevicesRequestModal";

    export default
    {
        name: "EFBDevices",
        mixins: [loadingMixin],

        components: {
            IpadDevicesRequestModal,
            // eslint-disable-next-line vue/no-unused-components
            LoadingButton,

            //Tabs,
            //TabPane,
            //Datepicker,
        },

        data(){
            return {
                device_uuid: this.$route.params.device_uuid,
                //Device: this.$route.params.Device,
                Device: {id:0},
                isActiveIpadDeviceRequestModal : false,
                ActiveReqType : 'O',
                ActiveIpadDevice_UUID:"",
                ActiveDevice:"",

            }
        },

        async created() {


           this.Device = this.$route.params.Device;
           var devicedata = await this.GetInspectorviewGetByUid(this.$route.params.device_uuid);

           this.Device = devicedata
           this.device_uuid = devicedata.devicE_UUID;
           await this.GetdeviceslistByuuid(this.device_uuid);
           await this.GetheartbeatsignalsByuuid(this.device_uuid);

        },

        methods: {

            ...mapActions("efb",["Getinspectorviewlist","GetdeviceslistByuuid","GetheartbeatsignalsByuuid","GetInspectorviewGetByUid"]),

            showIpadDeviceRequestModal(reqtype)
            {

                    this.ActiveReqType = reqtype;
                    this.isActiveIpadDeviceRequestModal = true;
                    this.ActiveDevice = this.Device;
                    this.ActiveIpadDevice_UUID = this.device_uuid;

            },

            closeIpadDeviceRequestModal()
            {
                this.isActiveIpadDeviceRequestModal = false;
            },

        },

        computed: {

            ...mapState("efb",["inpectorviewlist","deviceslistByuuid","heartbeatsignalsByuuid"]),



        },

    }
</script>

<style scoped>

    .fontsizesmall{
        font-size: 12px;
    }

    .request-table {
        overflow-y: scroll;
        height: 340px;
    }

    .sticky-head th {
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: white;


        outline: 1px solid #e9ecef;

        outline-offset: -1px;
        margin-top: 10px;

    }



    .list-item {
        border-bottom: 0;
        font-family: sans-serif;
        font-style: normal;
        font-size: 15px;
        color: #999999;
        font-weight: bold;
    }

    .level-item {
        align-items: center;
        display: flex;
        flex-basis: auto;
        flex-grow: 0;
        flex-shrink: 0;
        /* justify-content: center; */
    }

    .section {
        margin-top: -30px;
    }

    .message {
        cursor: pointer;
    }

    .box {
        cursor: pointer;
    }

    .left-main-level {
        display: inline-grid;
        float: left;
        margin-left: 9px;
        margin-bottom: -20px;
        /*margin-bottom: 6px;*/
    }

    .left-lable {
        float: left;
        margin-top: 5px;
    }

    .details-main {
        background-color: whitesmoke;
    }

    .details-label {
        font-size: 11px;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: #9e9e9e;
        font-weight: 700;
    }

    .has-background-danger {
        background-color: #ea1111a3 !important;
        color: #4a4a4a;
    }

    .has-background-success {
        background-color: #48c774a8 !important;
        color: #4a4a4a;
    }

    .open-button {
        float: right;
    }

    .close-button {
        float: right;
    }

</style>
